import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { base_url } from '../../../Api/Api';
import { Loader } from '../../../Global/Loader';

import Header from '../../../Global/Header';
import ItemTicket from './itemTicket';

const TicketList = (props) => {

    const [state, setState] = useState({
        data: [],
        loader: true
    })

    useEffect(() => {


        base_url.get(`tickets`)
            .then(response => {
                console.log(response.data.tickets)
                setState({
                    ...state,
                    data: response.data.tickets,
                    loader: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, []);

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <div className={`instructpg list-tickets ${state.loader ? '' : 'active'}`}>
                <Header
                    innerPage={true}
                    title={'تیکت'} />

                <div className="body-ticket">
                    {state.data.length == 0 ?
                        null
                        :
                        state.data.map(item =>
                            <ItemTicket
                                data={item} />
                        )
                    }
                </div>
                <div className="btn-base btn-black btn-sircle">
                    <Link to="/tickets/create-ticket">
                        <i className="icon-close"></i>
                    </Link>
                </div>

            </div>
        </React.Fragment>
    );
}

export default TicketList;